/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Product_Phone_Cta_Label1Inputs */

const vi_sitesettings_product_phone_cta_label1 = /** @type {(inputs: Sitesettings_Product_Phone_Cta_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chữ ô đặt qua điện thoại (máy tính)`)
};

/**

* @param {Sitesettings_Product_Phone_Cta_Label1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_product_phone_cta_label1 = /** @type {((inputs?: Sitesettings_Product_Phone_Cta_Label1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Product_Phone_Cta_Label1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_product_phone_cta_label1(inputs)
});
export { sitesettings_product_phone_cta_label1 as "siteSettings_product_phone_cta_label" }